import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgArrowDown(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M5.70723 13.7148C5.3167 13.3243 4.68354 13.3243 4.29302 13.7148C3.90249 14.1054 3.90249 14.7385 4.29302 15.1291L10.5858 21.4152C11.3668 22.1962 12.6332 22.1962 13.4142 21.4152L19.707 15.1212C20.0976 14.7307 20.0976 14.0976 19.707 13.707C19.3165 13.3165 18.6833 13.3165 18.2928 13.707L13 19V3C13 2.44772 12.5523 2 12 2C11.4477 2 11 2.44772 11 3V19L5.70723 13.7148Z", fill: "currentColor" })));
}
export default SvgArrowDown;
